import { render, staticRenderFns } from "./coolPreview.component.vue?vue&type=template&id=453e0bf3&scoped=true&"
import script from "./coolPreview.component.vue?vue&type=script&lang=js&"
export * from "./coolPreview.component.vue?vue&type=script&lang=js&"
import style0 from "./coolPreview.component.vue?vue&type=style&index=0&id=453e0bf3&lang=scss&scoped=true&"
import style1 from "./coolPreview.component.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453e0bf3",
  null
  
)

export default component.exports